import { Component, OnInit } from '@angular/core';
import { CommonHelper } from 'src/app/helpers/common';

@Component({
  selector: 'app-app-landing',
  templateUrl: './app-landing.component.html',
  styleUrls: ['./app-landing.component.css']
})
export class AppLandingComponent implements OnInit {

  private ops:number = 1;
  public get appUrl():String{
    return this.ops == 1 ? 'https://apps.apple.com/mx/app/extrabase/id386828865' : 
    'https://play.google.com/store/apps/details?id=lmp.system&hl=es_419&gl=US&pli=1';
  };

  constructor(private commonHelper: CommonHelper) {
    this.commonHelper.currentUrl = 'getApp';
  }

  ngOnInit() {
    this.ops = this.commonHelper.getMobileOperatingSystem();
  }

}
